import { render } from "./DirectMessageThread.vue?vue&type=template&id=74935168"
import script from "./DirectMessageThread.vue?vue&type=script&lang=js"
export * from "./DirectMessageThread.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__